import React from 'react'

const PluginForm = () => {
  return (
    <div>PluginForm</div>
  )
}

export default PluginForm